<div class="snackbar-container">
    <span>{{ data.message }}</span>
    <div class="snackbar-actions">
        @if (data.link) {
        <button mat-button (click)="onOpenLink()" class="link-btn">
            {{data.label}}
        </button>
        }
        <button mat-button (click)="onClose()" class="close-btn">
            Close
        </button>
    </div>
</div>